<template>
  <div v-if="notify.type > 0" >
    <v-alert type="success" v-if="notify.type == 1">
      {{ notify.message }}
    </v-alert>

    <v-alert type="info" v-if="notify.type == 2">
      {{ notify.message }}
    </v-alert>

    <v-alert type="warning" v-if="notify.type == 3">
      {{ notify.message }}
    </v-alert>
    <v-alert type="error" v-if="notify.type == 4 && notify.errors.length > 0 ">
      <div class="row" v-for="item in notify.errors" :key="item">
          {{ item }}
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  methods: {},
  props: {
    notify: { type: Object },
  },
  computed: {

  },
  watch: {
    notify() {
      
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Notification.vue